import { useCallback, useEffect, useState } from "react";
import { CheckCircle2, Clock, MailOpen, XCircle } from "lucide-react";
import { api, fmtDateTime } from "@/lib/api";

const STATES = {
  completed: { l: "Firmato", c: "text-emerald-700", I: CheckCircle2, at: "signed_at" },
  signed: { l: "Firmato", c: "text-emerald-700", I: CheckCircle2, at: "signed_at" },
  delivered: { l: "Email aperta", c: "text-sky-700", I: MailOpen, at: "delivered_at" },
  sent: { l: "Email inviata, in attesa", c: "text-amber-700", I: Clock, at: "sent_at" },
  declined: { l: "Ha rifiutato", c: "text-red-700", I: XCircle, at: "declined_at" },
};
const WAIT = { l: "In attesa del firmatario precedente", c: "text-slate-500", I: Clock };

export function SignersStatus({ cid, active }) {
  const [rows, setRows] = useState(null);
  const load = useCallback(() => api.get(`/contracts/${cid}/signers`).then((r) => setRows(r.data)).catch(() => setRows([])), [cid]);

  useEffect(() => {
    load();
    if (!active) return undefined;
    const t = setInterval(load, 60000);
    return () => clearInterval(t);
  }, [load, active]);

  if (!rows?.length) return null;
  return (
    <div className="pt-2 mt-2 border-t border-slate-100 space-y-2" data-testid="contract-signers">
      <p className="font-semibold text-slate-800">Stato firmatari</p>
      {rows.map((s) => {
        const st = STATES[s.status] || WAIT;
        return (
          <div key={s.order} className="flex items-start gap-2" data-testid={`contract-signer-${s.order}`}>
            <st.I className={`h-4 w-4 mt-0.5 shrink-0 ${st.c}`} />
            <div>
              <p className="text-slate-900 font-medium">{s.name}</p>
              <p className={st.c} data-testid={`contract-signer-${s.order}-status`}>{st.l}{st.at && s[st.at] ? ` · ${fmtDateTime(s[st.at])}` : ""}</p>
            </div>
          </div>
        );
      })}
    </div>
  );
}
